export abstract class ResourceBaseUrlBuilder {
  public abstract buildBaseUrl(append?: string): string;
}
